var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VSelect',{staticClass:"w-full",attrs:{"options":_vm.keyMaps,"clearable":false,"reduce":function (keyMap) { return keyMap.id; },"label":"id"},on:{"option:selected":_vm.keyMapChanged},scopedSlots:_vm._u([{key:"selected-option",fn:function(ref){
var id = ref.id;
var name = ref.name;
return [_vm._v(" "+_vm._s(name ? name : _vm.$t(("laboratory.key-maps." + (id.toLowerCase()))))+" ")]}},{key:"option",fn:function(ref){
var id = ref.id;
var name = ref.name;
return [_vm._v(" "+_vm._s(name ? name : _vm.$t(("laboratory.key-maps." + (id.toLowerCase()))))+" ")]}}]),model:{value:(_vm.activeKeyMapId),callback:function ($$v) {_vm.activeKeyMapId=$$v},expression:"activeKeyMapId"}})}
var staticRenderFns = []

export { render, staticRenderFns }